export default {
  setId(state, payload) {
    state.id = payload;
  },
  setStep(state, { stepName, step }) {
    state[stepName] = step;
  },
  setStepIsCompleted(state, { stepName, step }) {
    state[stepName].isCompleted = step;
  },
  setApplication(state, payload) {
    const { id, currentStatus } = payload;
    const {
      intro,
      questions,
      vehiclesInfo,
      companyInformation,
    } = payload.steps;

    state.id = id;
    state.currentStatus = currentStatus;
    state.intro = intro;
    state.questions = questions;
    state.vehiclesInfo = vehiclesInfo;
    state.companyInformation = companyInformation;
  },
  resetApplication(state) {
    const {
      intro,
      questions,
      vehiclesInfo,
      companyInformation,
    } = state.defaultSteps;

    state.id = null;
    state.currentStatus = 'new';
    state.intro = intro;
    state.questions = questions;
    state.vehiclesInfo = vehiclesInfo;
    state.companyInformation = companyInformation;
  },
};
